export const RESET_INSIGHTS_OBJ = "RESET_INSIGHTS_OBJ";
export const RESET_INSIGHTS_STATUS = "RESET_INSIGHTS_STATUS";
export const INSIGHTS_ERROR = "INSIGHTS_ERROR";

export const SET_INSIGHTS = "SET_INSIGHTS";
export const SET_INSIGHTS_SUCCESS = "SET_INSIGHTS_SUCCESS";
